module.exports = __webpack_public_path__ + "img/61.945e435c.jpg";